module.exports = __webpack_public_path__ + "img/about_03.79f68e83.png";